﻿import Vue from "vue";
import common from "../../common";
import core from "../../core";
import HotEditableFormAction_ from "../vue/hotEditable/HotEditableFormAction";
import utilities_ from "../utilities";
import FormService_ from "../../services/FormService";
import FormNode_ from "../vue/hotEditable/FormNode";
import context_ from "../context";
import PageService_ from "../../services/PageService";
import NotesVue_ from "../vue/NotesVue";

declare function require(module: string): unknown;
const context = require("../context") as typeof context_;
const utilities = require("../utilities") as typeof utilities_;
// const HotEditableFormAction = require("../vue/hotEditable/HotEditableFormAction") as HotEditableFormAction_;
// const FormService = require("../../services/FormService") as FormService_;
// const FormNode = require("../vue/hotEditable/FormNode") as FormNode_;
// const PageService = require("../../services/PageService") as PageService_;
// const NotesVue = require("../vue/NotesVue") as NotesVue_;
//const jsClasses = require("../../../js/jsClasses") as any;

interface ISettings {
    /** Valeur de l'attribut HTML "name" du formulaire contenant les champs */
    formName: string;
    /** Valeur de l'attribut HTML "id" du module Vuejs */
    vueElId: string;
    /** URL de l'API qui sera appeler lors de la sauvegarde  */
    updateApiUrl: string;
    customData?: common.IPostCustomData;
    concurrencySumCheck: string;
    items?: common.INote[];
}

interface IResponseData extends common.IHotEditableFormResponseData {
    notes?: common.INote[];
    note?: common.INote;
    commentaireId?: string;
    commentaires?: common.INoteCommentaire[];
}

class DefaultNotes implements common.IWebComponent {
    private _isInit = false;
    private _formService?: FormService_;
    private _pageService?: PageService_;
    private _editVue = null as NotesVue_ | null;
    private _loader = null as core.Loader | null;
    private _vueElId?: string;
    private _updateApiUrl?: string | null;
    private _liveUpdateOnEditMode?: boolean;
    private _isEditionAlwaysOn?: boolean;
    private _confirmPopup = null as core.ConfirmationPopup | null;
    private _customData = null as common.IPostCustomData | null;

    init(s: ISettings) {
        if (this._isInit)
            return;
        this._isInit = true;

        // configuration
        this._updateApiUrl = s.updateApiUrl || null;
        this._vueElId = s.vueElId || (() => { throw "La propriété 'settings.vueElId' est requise."; })();
        this._isEditionAlwaysOn = true;
        this._liveUpdateOnEditMode = false;
        this._customData = s.customData || {};

        this._pageService = new PageService_();
        this._formService = new FormService_(s.formName);
        this._loader = new core.Loader(this._vueElId);
        this._confirmPopup = new core.ConfirmationPopup("#ActionConfirmPopup.mod-popup");

        this.setupVue(s);

        return this;
    }

    destroy() {
        this._editVue?.shared?.destroyComponentsByNode();
        this._editVue?.$destroy();
        this._editVue = null;//DESTROY (TEST)
    }

    private setupVue(s: ISettings) {

        Vue.prototype.$initialData = {
            vueElId: this._vueElId,
            formName: s.formName,
            loadFormModeFromUrl: false,
            items: s.items || [],
            includesConcurrencySumCheck: true,
            concurrencySumCheck: s.concurrencySumCheck || null
        };

        this._editVue = new NotesVue_()
            .setOnCheckItemClickCallbak(item => {
                this.onCheckItemClick(item);
            })
            .setOnEditItemClickCallbak(item => {
                this.onEditItemClick(item);
            })
            .setOnDeleteItemClickCallbak(item => {
                this.onDeleteItemClick(item);
            })
            .setOnEditCommentClickCallbak(comment => {
                this.onEditCommentClick(comment);
            })
            .setOnEditCommentCancelClickCallbak((item, comment) => {
                this.onEditCommentCancelClick(item, comment);
            })
            .setOnEditCommentSaveClickCallbak((item, comment) => {
                this.onEditCommentSaveClick(item, comment);
            })
            .setOnDeleteCommentClickCallbak(comment => {
                this.onDeleteCommentClick(comment);
            })
            .setOnAddCommentClickCallbak(item => {
                this.onAddCommentClick(item);
            })
            .setOnAddCommentCancelClickCallbak(item => {
                this.onAddCommentCancelClick(item);
            })
            .setOnAddCommentSaveClickCallbak(item => {
                this.onAddCommentSaveClick(item);
            });

        this._editVue?.setManageButtonsOnFormModeChange(false);

        this._editVue?.shared?.setActionCallback((a: HotEditableFormAction_) => {
            this.onFormAction(a);
        }).setErrorCallback((errors: common.IError[], config?: common.IHotEditableFormConfig) => {
            this.onFormActionError(errors, null, config);
        });

        this._editVue?.shared?.setupForm(this._isEditionAlwaysOn);
    }
    registerFormManagerParentNode(parent: FormNode_, containerFieldName: string, url: string | null) {
        if (this._editVue?.formManager?.formNode) {
            this._editVue.formManager.formNode.onRegister(containerFieldName, url, this);
            parent?.registerChildNode(this._editVue.formManager.formNode);
        }
        return this;
    }
    /** Sera appelé par le embedded field pour y injecter le navContext */
    insertNavContextHiddenField(navContextId: string) {
        utilities.insertNavContextHiddenField(this._editVue?.shared?.getFormName(), navContextId);
        return this;
    }
    // /** Sera appelé par le embedded field pour y injecter le sum check */
    // insertConcurrencySumCheckHiddenField(sumCheck: string) {
    //     utilities.insertConcurrencySumCheckHiddenField(this._editVue?.shared?.getFormName(), sumCheck);
    //     return this;
    // }
    private onCheckItemClick(item?: common.INote) {
        // const f = () => this._editVue?.checkItem(item);
        // const t = this._editVue?.getItemTypeTitle(item);
        // this._confirmPopup?.show(t, "Êtes-vous certain de vouloir compléter cette note?", f);
        this._editVue?.checkItem(item);
    }
    private onEditItemClick(item?: common.INote) {
        const f = () => this._editVue?.loadItem(item);
        if (this._editVue?.isAddingItem())
            this._confirmPopup?.show("Attention", "Une nouvelle note est en cours de création, êtes-vous certain de vouloir continuer?", f);
        else if (this._editVue?.isEditingItem())
            this._confirmPopup?.show("Attention", "Des modifications sont en cours et seront perdues, êtes-vous certain de vouloir continuer?", f);
        else if (this._editVue?.isAddingComment())
            this._confirmPopup?.show("Attention", "Un nouveau commentaire est en cours de rédaction, êtes-vous certain de vouloir continuer?", () => {
                this._editVue?.closeNewComment();
                f();
            });
        else
            f();
    }
    private onDeleteItemClick(item?: common.INote) {
        const f = () => this._editVue?.deleteItem(item);
        const t = this._editVue?.getItemTypeTitle(item);
        this._confirmPopup?.show(t, "Êtes-vous certain de vouloir supprimer cette note?", f);
    }
    private onEditCommentClick(comment?: common.INoteCommentaire) {
        const f = () => this._editVue?.loadComment(comment);
        if (this._editVue?.isAddingComment())
            this._confirmPopup?.show("Attention", "Un nouveau commentaire est en cours de création, êtes-vous certain de vouloir continuer?", f);
        else
            f();
    }
    private onEditCommentCancelClick(item?: common.INote, comment?: common.INoteCommentaire) {
        const f = () => this._editVue?.closeComment(comment);
        if (this._editVue?.isEditingComment(comment))
            this._confirmPopup?.show("Attention", "Ce commentaire est en cours de modification, êtes-vous certain de vouloir continuer?", f);
        else
            f();
    }
    private onEditCommentSaveClick(item?: common.INote, comment?: common.INoteCommentaire) {
        if ((comment?.editedText || '').trim())
            this._editVue?.saveComment(item, comment);
        else
            this._confirmPopup?.show("Attention", "Ce commentaire sera supprimé, êtes-vous certain de vouloir continuer?", () => {
                this._editVue?.deleteComment(comment);
            });
    }
    private onDeleteCommentClick(comment?: common.INoteCommentaire) {
        const f = () => this._editVue?.deleteComment(comment);
        this._confirmPopup?.show("Attention", "Êtes-vous certain de vouloir supprimer ce commentaire", f);
    }
    private onAddCommentClick(item?: common.INote) {
        const f = () => this._editVue?.loadNewComment(item);
        if (this._editVue?.isAddingComment())
            this._confirmPopup?.show("Attention", "Un nouveau commentaire est en cours de création, êtes-vous certain de vouloir continuer?", f);
        else if (this._editVue?.isEditingComment())
            this._confirmPopup?.show("Attention", "Un commentaire est en cours de modification, êtes-vous certain de vouloir continuer?", f);
        else
            f();
    }
    private onAddCommentCancelClick(item?: common.INote) {
        const f = () => this._editVue?.closeNewComment(item);
        if (this._editVue?.isAddingComment(item))
            this._confirmPopup?.show("Attention", "Ce commentaire est en cours de rédaction, êtes-vous certain de vouloir continuer?", f);
        else
            f();
    }
    private onAddCommentSaveClick(item?: common.INote) {
        if (item?.commentNewText)
            this._editVue?.saveNewComment(item);
        else
            this._editVue?.closeNewComment(item);
    }
    private onFormAction(action: HotEditableFormAction_) {
        if (this._formService?.actionHasError(action))
            return;

        const isEditionFormMode = action.isEditionFormMode();
        const isNoteAction = action.isButtonClick();
        const actionValue = action.getActionValue();
        var actionType = action.getActionType();

        if (this._liveUpdateOnEditMode && actionType === common.HotEditableActionTypes.unknown)
            actionType = common.HotEditableActionTypes.update;

        if (isEditionFormMode && actionType === common.HotEditableActionTypes.unknown)
            return;

        if (isNoteAction) {
            const bn = action.getButtonName();
            const reset = () => this._editVue?.resetCurrentItem();

            if (this._editVue?.isEditingItem()) {
                // Edition

                if (bn === "Cancel") {
                    if (this._editVue?.hasDescription())
                        this._confirmPopup?.show("Attention", "Une note est en cours de modification, êtes-vous certain de vouloir continuer?", reset);
                    else
                        reset();
                    return;
                }
            }

            else {
                // Creation

                if (bn === "Clear") {

                    if (this._editVue?.hasDescription())
                        this._confirmPopup?.show("Attention", "Une nouvelle note est en cours de création, êtes-vous certain de vouloir continuer?", reset);
                    else
                        reset();
                    return;
                }
            }

            // const itemTypeNamePrefix = "ApplyItemType";
            // if (bn.length > itemTypeNamePrefix.length) {
            //     const parts = bn.split("_");
            //     if (parts.length === 2 && parts[0] === itemTypeNamePrefix) {
            //         const value = action.getActionValue();
            //         this._editVue?.setCurrentItemType(value);
            //         return;
            //     }
            // }
        }

        const f = () => {

            this._formService?.validateAndPost(
                this._updateApiUrl,
                null,
                {
                    posted_actionType: actionType,
                    posted_actionValue: actionValue,
                    posted_formName: this._editVue?.shared?.getFormName(),
                    posted_fieldName: action.getFieldOrButtonName(),
                    posted_currentCulture: context.culture.get(),
                    posted_currentUrl: utilities.currentUrl(),
                    posted_customData: utilities.ensureCustomDataIsValid(this._customData),
                    posted_previousPageUrl: null,
                    posted_currentEmbeddedComponentName: this._editVue?.shared?.getCurrentEmbeddedComponentName(),
                    posted_bag: this._editVue?.getBagRaw(),
                    posted_isControlClick: action.getButtonClickContext().isCtlClick === true
                } as common.IHotEditableFormPostArguments,
                (data: IResponseData) => {
                    this.onFormActionSuccess(action, data);
                },
                (e: any, config: any) => {
                    this.onFormActionError(e, action, config);
                });
        };

        if (isNoteAction) {
            // Action depuis la section des notes (haut)

            if (this._editVue?.isAddingComment())
                this._confirmPopup?.show("Attention", "Un nouveau commentaire est en cours de création. Il sera supprimé. Êtes-vous certain de vouloir continuer?", () => {
                    this._editVue?.closeNewComment();
                    this._editVue?.$nextTick(() => {
                        f();
                    });
                });
            else if (this._editVue?.isEditingComment())
                this._confirmPopup?.show("Attention", "Un commentaire est en cours de modification. Les modifications seront perdues. Êtes-vous certain de vouloir continuer?", () => {
                    this._editVue?.closeComment();
                    this._editVue?.$nextTick(() => {
                        f();
                    });
                });
            else f();
        }

        else f();
    }

    private onFormActionSuccess(action: HotEditableFormAction_, data?: IResponseData) {
        data = data || {};

        const actionType = action.getActionType();
        const actionValue = action.getActionValue();
        const isButtonClick = action.isButtonClick();
        const isEditionFormMode = action.isEditionFormMode();
        const isUpdateAction = isButtonClick && actionType === common.HotEditableActionTypes.update;
        const isDeleteAction = !isUpdateAction && actionType === common.HotEditableActionTypes.delete;
        const showMessages = data.disableAllMessages !== true;
        const showAutoSuccessMessages = showMessages && data.disableAutomaticMessages !== true;
        const changedFieldName = action.getFieldName();
        const buttonClickContext = action.getButtonClickContext();

        if (data.outdatedContent)
            return this._pageService?.applyOutdatedContent(data, this._editVue);

        // Doit etre ouvert avant le refresh du widget si une URL de fichier typiquement en target=blank
        const openRedirectUrlInBlankPage = data.redirectUrl && utilities.openInBlankPage(data.redirectUrlOptions);
        if (openRedirectUrlInBlankPage)
            utilities.redirectWithDelay(data.redirectUrl, 1, true);

        const displayCustomMessage = (immediateDisplay: boolean, text: string, name?: string, messageType?: common.MessageTypes, autoClose?: boolean) => {
            messageType = messageType || common.MessageTypes.success//<- default is success
            if (this._editVue?.shared)
                if (!this._editVue.shared.displayMessage(name, text, messageType))
                    this._formService?.displayMessage(text, messageType, immediateDisplay, autoClose);
        }
        if (!this._editVue?.shared) {
            //debugger;
            console.warn("[UPA] 'EditVue' already disposed.");
            return;
        }

        var succesMessageSended = false;
        if (this._editVue?.shared?.isHotEmbeddedComponent()) {
            // Widgets -> brothers
            if (data.refreshBrotherEmbeddedComponents)
                this._editVue?.refreshBrotherEmbeddedComponents();
            else if (data.restoreBrotherEmbeddedComponents)
                this._editVue?.restoreBrotherEmbeddedComponents();
            else if (data.ensureBrotherEmbeddedComponentsIsDefaultUrl)
                this._editVue?.ensureBrotherEmbeddedComponentsIsDefaultUrl();
            // Widgets -> all
            if (data.hotEmbeddedComponentsToUpdate?.length) {
                if (showMessages) {
                    const updateCurrentEmbededForm = utilities.any(data.hotEmbeddedComponentsToUpdate, x => !x.name);
                    if (updateCurrentEmbededForm && data.messages?.length) {
                        for (let i = 0; i < data.messages.length; i++) {
                            const m = data.messages[i];
                            const ac = m.autoClose === true || m.autoClose === false ? m.autoClose : true;//default=TRUE
                            displayCustomMessage(true, m.text, m.name, m.messageType, ac);
                        }
                        // if (!this._editVue?.shared?.displayMessage(data.messageName, data.messages, customMessageType))
                        //     this._formService?.displayMessage(data.messages, customMessageType, false, true);
                    } else if (showAutoSuccessMessages && !succesMessageSended) {
                        this._formService?.displaySuccessMessageFromAction(action, true, true, this._liveUpdateOnEditMode);
                        succesMessageSended = true;
                    }
                }

                if (this._editVue?.shared)
                    if (this._editVue.shared.updateHotEmbeddedComponents(data.hotEmbeddedComponentsToUpdate))
                        return;
            }
        }

        if (isDeleteAction) {
            var redirectUrl = data.redirectUrl;
            if (!redirectUrl && data.forceRedirectOnDeleteAction)
                redirectUrl = '/';
            if (redirectUrl) {
                utilities.redirect(redirectUrl);
                return;
            }
        }

        this._editVue?.shared?.updateConcurrencySumCheck(data.updatedConcurrencySumCheck);
        this._editVue?.updateBag(data.bag);

        const repost = () => this._editVue?.shared?.applyUpdate(actionValue, actionType, isButtonClick, buttonClickContext, changedFieldName);
        if (FormService_.confirm(
            this._editVue?.formManager?.getFormName(),
            this._confirmPopup,
            data?.confirmationMessages,
            () => {
                // Accepted
                repost();
            },
            (returnToApiOnDenied: boolean) => {
                // Denied

                if (returnToApiOnDenied) {
                    repost();
                    return;
                }

                if (this._editVue?.shared?.confirmationRejected())
                    this._formService?.displayNotSavedErrorMessageImediately();
            }))
            return;

        if (isUpdateAction || data.redirectUrl) {
            const url = data.redirectUrl || null;
            if (url) {
                if (showMessages)
                    if (data.messages?.length) {
                        for (let i = 0; i < data.messages.length; i++) {
                            const m = data.messages[i];
                            const ac = m.autoClose === true || m.autoClose === false ? m.autoClose : true;//default=TRUE
                            displayCustomMessage(false, m.text, m.name, m.messageType, ac);
                        }

                        // if (!this._editVue?.shared?.displayMessage(data.messageName, data.messages, customMessageType))
                        //     this._formService?.displayMessage(data.messages, customMessageType, false, true);
                    } else if (showAutoSuccessMessages && !succesMessageSended) {
                        this._formService?.displaySuccessMessageFromAction(action, false, true, this._liveUpdateOnEditMode);
                        succesMessageSended = true;
                    }

                if (!openRedirectUrlInBlankPage)
                    // Ne pas rouvrir une seconde fois l'url en target=blank
                    utilities.redirectWithOptions(url, data.redirectUrlOptions);

                return;
            }
        }

        this._editVue?.closeNewComment();
        this._editVue?.closeComment();
        this._editVue?.resetCurrentItem();

        if (data.notes)
            this._editVue?.setItems(data.notes);
        else if (data.note)
            this._editVue?.setItem(data.note);

        if (data.commentaireId && data.commentaires)
            this._editVue?.setComments(data.commentaireId, data.commentaires);

        if (data.fieldsToUpdate)
            for (let i = 0; i < data.fieldsToUpdate.length; i++) {
                const updatedField = data.fieldsToUpdate[i];
                if (updatedField)
                    this._editVue?.shared?.updateFieldFromApi(updatedField);
            }

        if (showMessages)
            if (data.messages?.length) {
                for (let i = 0; i < data.messages.length; i++) {
                    const m = data.messages[i];
                    const ac = m.autoClose === true || m.autoClose === false ? m.autoClose : true;//default=TRUE
                    displayCustomMessage(true, m.text, m.name, m.messageType, ac);
                }
                // if (!this._editVue?.shared?.displayMessage(data.messageName, data.messages, customMessageType))
                //     this._formService?.displayMessage(data.messages, customMessageType, true, true);
            }
            else if (showAutoSuccessMessages && !succesMessageSended) {
                this._formService?.displaySuccessMessageFromAction(action, true, true, this._liveUpdateOnEditMode);
                succesMessageSended = true;
            }

        if (isEditionFormMode && !this._isEditionAlwaysOn && !this._liveUpdateOnEditMode)
            this._editVue?.shared?.setAsHotEditableFormMode();
    }

    private onFormActionError(errors: common.IError[], action?: HotEditableFormAction_ | null, config?: common.IHotEditableFormConfig) {
        config = config || {};

        for (let i = 0; i < errors.length; i++) {
            const error = errors[i];

            if (error.code !== 110) {

                if (context.env.currentIsDev || context.env.currentIsLocal) {
                    utilities.printError(error.message + ' (code: ' + error.code + ')');
                    this._formService?.displayErrorImediately(new core.Error("Une erreur système est survenue et est affichée dans la console du navigateur.", error.code));
                }
                else
                    this._formService?.displayErrorImediately(new core.Error(error.message));

                return;
            }

            if (config.disableAutomaticMessages)
                return;

            // Functional
            const fieldFound = this._editVue?.shared?.displayFieldError(this._editVue?.shared?.getFormName(), error, true);
            if (fieldFound) {
                this._formService?.displayNotSavedErrorMessageImediately();
                return;
            }

            this._formService?.displayErrorImediately(new core.Error(error.message));
        }
    }
}
export = DefaultNotes;